import itLocale from 'element-ui/lib/locale/lang/it' //引入element语言包
const it = {
  Login: {
    ToLogin: 'login',
    PhoneLogin: 'Login con numero di telefono',
    EmailLogin: 'Accesso via email',
    PhonePlaceholder: 'Inserisci il tuo numero di telefono',
    EmailPlaceholder: 'Enter email',
    Code: 'Codice di verifica',
    and: 'e',
    BeforeText: 'La creazione di un account rappresenta il tuo accordo e la conformità',
    UserAgreement: 'Accordo utente',
    privacy: 'Informativa sulla privacy',
    errorMessage: 'Errore del codice di verifica',
    readTitle: 'Leggere e accettare il seguente accordo',
    readBefore: 'Per garantire la sicurezza delle tue informazioni personali, ti preghiamo di leggere e accettare prima',
    cancel: 'annulla',
    agree: 'Accettare e continuare',
    error1:'Inserisci un indirizzo email valido',
    error2:'Inserisci il numero di cellulare corretto',
    error3:'Inserisci il codice di verifica',
    success:'Login riuscito'
  },
  ...itLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default it;
